import { render, staticRenderFns } from "./TrafficPerMonth.vue?vue&type=template&id=92528b46&scoped=true&"
import script from "./TrafficPerMonth.vue?vue&type=script&lang=js&"
export * from "./TrafficPerMonth.vue?vue&type=script&lang=js&"
import style0 from "./TrafficPerMonth.vue?vue&type=style&index=0&id=92528b46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92528b46",
  null
  
)

export default component.exports